<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div v-if="evaluationOptionLabel && evaluationOptionLabel.length > 0">
      評価表示：{{ evaluationOptionLabel }}
    </div>
    <div v-if="segmentLabel && segmentLabel.length > 0">
      顧客セグメント：{{ segmentLabel }}
    </div>
    <div>評価項目：{{ evaluationsLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluationOption: {
      type: String,
      default: '',
    },
    customerSegment: {
      type: String,
      default: '',
    },
    evaluations: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationOptionLabel() {
      return this.$store.state.labels.evaluationOption[this.evaluationOption]
    },
    segmentLabel() {
      return this.$store.state.labels.customerSegment[this.customerSegment]
    },
    evaluationsLabel() {
      const labels = this.$store.state.labels.evaluations
      let l = []

      for (const e of this.evaluations) {
        l.push(labels[e])
      }

      return l.join('、')
    },
  },
}
</script>
